import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingOutlined } from '@ant-design/icons'

import B2becButton from '@/components/B2becButton'
import { PlusIcon } from '@/components/Icons'
import LoadingSkeleton from '@/components/Skeletons'
import useHover from '@/hooks/useHover'
import { useMediaQuery } from '@/hooks/useMediaQuery'
import BREAKPOINTS from '@/libs/constants/breakpoints'

import styles from './WishlistItem.module.scss'

interface WishlistItemProps {
  wishlistId: string
  wishlistName: string
  productCount: number
  loadingIds: Record<string, boolean>
  isShared: boolean
  onClick: () => void
}

export function WishlistItem({
  wishlistId,
  wishlistName,
  productCount,
  loadingIds,
  isShared,
  onClick,
}: WishlistItemProps) {
  const { t } = useTranslation()
  const hoverRef = useRef(null)
  const isHover = useHover(hoverRef)
  const isLargerThan992 = useMediaQuery(`(min-width:${BREAKPOINTS.lg}px)`)

  return (
    <div ref={hoverRef} className={styles.wrapper}>
      <div className={styles.content}>
        <span className={styles.name}>{wishlistName}</span>
        <span className={styles['sub-information']}>
          {t('plural.productWithCount', { count: productCount ?? 0 })}
        </span>
      </div>
      {!isShared && (
        <div className={styles.action}>
          {isLargerThan992 && isHover
            ? (
              <B2becButton
                ghost
                className={styles['add-button']}
                loading={loadingIds[wishlistId]}
                onClick={onClick}
              >
                {t('buttonTexts.add')}
              </B2becButton>
            )
            : null}
          {!isLargerThan992 && (
            <div className={styles.action}>
              <button
                className={`button-as-link ${styles['add-button']}`}
                type="button"
                onClick={onClick}
              >
                {loadingIds[wishlistId] ? <LoadingOutlined /> : <PlusIcon />}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

function WishlistItemLoading() {
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.content} ${styles.skeletonContent}`}>
        <span className={styles.name}>
          <LoadingSkeleton style={{ width: '100%', height: 20 }} />
        </span>
        <span className={styles['sub-information']}>
          <LoadingSkeleton style={{ width: '100%', height: 20 }} />
        </span>
      </div>
    </div>
  )
}

WishlistItem.Loading = WishlistItemLoading
